import { FaArrowDownAZ, FaArrowDownWideShort } from "react-icons/fa6"
import { ButtonWithIcon } from "./ButtonWithIcon"

export type SortOrder = "alphabetical" | "magnitude"

type SortOrderToggleProps = {
  value: SortOrder
  onChange: (order: SortOrder) => void
  magnitudeLabel: string
}
export default function SortOrderToggle({
  value,
  onChange,
  magnitudeLabel,
}: SortOrderToggleProps) {
  return (
    <div className="flex gap-4 shrink-0">
      <ButtonWithIcon
        title={<span className="hidden md:inline">Alphabetisch</span>}
        icon={
          <FaArrowDownAZ
            className={value === "alphabetical" ? "!text-[#3E9E29]" : ""}
          />
        }
        className={
          value === "alphabetical" ? "!border-[#3E9E29] !text-[#3E9E29]" : ""
        }
        onClick={() => onChange("alphabetical")}
      />
      <ButtonWithIcon
        title={<span className="hidden md:inline">{magnitudeLabel}</span>}
        icon={
          <FaArrowDownWideShort
            className={value === "magnitude" ? "!text-[#3E9E29]" : ""}
          />
        }
        className={
          value === "magnitude" ? "!border-[#3E9E29] !text-[#3E9E29]" : ""
        }
        onClick={() => onChange("magnitude")}
      />
    </div>
  )
}
